import { Box, Divider, Typography } from '@mui/material';

import { CustomerProductLulaBank } from '@features/workspace/components/customer-product-lula-bank';
import { CollapseGroup } from '@features/workspace/components/shared/collapse-group';
import { CustomerProductLulaCredit } from '@features/workspace/components/customer-product-lula-credit';
import { useId } from 'react';
import {
  selectBankAccounts,
  selectFundingApplications,
} from '@features/workspace/store/selectors';
import { useAppSelector } from '@store/hooks';

export function CustomerProducts() {
  const id = useId();

  const bankAccounts = useAppSelector(selectBankAccounts);
  const fundingApplications = useAppSelector(selectFundingApplications);

  const bankingProductCount = bankAccounts?.length ?? 0;
  const creditProductCount = fundingApplications?.length ?? 0;

  const lulaBankProductContainer = <CustomerProductLulaBank />;
  const lulaCreditProductContainer = <CustomerProductLulaCredit />;

  const properties: Array<any> = [
    {
      id: 'lulabank',
      header: 'Lula Bank',
      counter: bankingProductCount,
      component: lulaBankProductContainer,
    },
    {
      id: 'lulacredit',
      header: 'Lula Credit',
      counter: creditProductCount,
      component: lulaCreditProductContainer,
    },
  ];

  return (
    <>
      <Typography variant="h6">Customer products</Typography>

      <Box display="flex" flexDirection="column" mt={2.5}>
        {properties.map((item: any, iItem: number) => (
          <Box key={`${id}-${item.id}`}>
            {!!iItem && (
              <Box ml={-1} width={1}>
                <Divider />
              </Box>
            )}
            <CollapseGroup
              counter={item?.counter}
              header={item?.header}
              id={item?.id}
            >
              {item?.component}
            </CollapseGroup>
          </Box>
        ))}
      </Box>
    </>
  );
}
